import { createContext, useContext, useMemo, useState } from 'react';
import { EventListTabType } from '../queues/types';

type ContextType = {
    setTab: (tab: EventListTabType) => void;
    tab: EventListTabType;
};

const FrEventsListTabContext = createContext<ContextType>({
    setTab() {},
    tab: 'ALL',
});

export function FrEventsListTabProvider(props: { children: React.ReactNode }) {
    const [tab, setTab] = useState<EventListTabType>('ALL');
    const contextValue = useMemo(() => {
        return {
            tab,
            setTab,
        };
    }, [tab, setTab]);
    return (
        <FrEventsListTabContext.Provider value={contextValue}>
            {props.children}
        </FrEventsListTabContext.Provider>
    );
}

export function useFrEventsListTab() {
    return useContext(FrEventsListTabContext);
}
